import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { scrollOffsetAtom } from '../recoil/atom';
export function useScrollIntoView(defaultRef) {
    const scrollOffset = useRecoilValue(scrollOffsetAtom);
    const scrollTo = useCallback((userRef) => {
        const ref = userRef || defaultRef;
        if (ref) {
            const { top } = ref.getBoundingClientRect();
            const { top: bodyTop } = document.body.getBoundingClientRect();
            const offsetPosition = top - bodyTop - (scrollOffset ?? 0);
            window.scrollTo({
                behavior: 'smooth',
                top: offsetPosition,
            });
            return true;
        }
        return false;
    }, [defaultRef, scrollOffset]);
    return scrollTo;
}
